module.exports = __webpack_public_path__ + "static/key-puzzle-c5b80ce116a3fb7a197a060c4c6c9268.webp";